import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import thunk from 'redux-thunk';
import rootReducers from './appStore/index';
import storage from 'redux-persist/lib/storage';
import autoMergeLevel2 from 'redux-persist/lib/stateReconciler/autoMergeLevel2';

const initialState = {};

// The `app` slice mixes navigation history (worth keeping) with volatile UI flags
// (not worth keeping). `loading: true` written to storage mid-request used to
// rehydrate into a permanent full-screen spinner that only clearing site data
// or switching browsers could fix. Reset the flags both when writing and when
// reading, so browsers that already hold a poisoned value recover on next load.
const VOLATILE_APP_STATE = { loading: false, isOnline: false, isMobile: false };
const resetVolatileAppState = createTransform(
    (inboundState) => ({ ...inboundState, ...VOLATILE_APP_STATE }),
    (outboundState) => ({ ...outboundState, ...VOLATILE_APP_STATE }),
    { whitelist: ['app'] }
);

const persistConfig = {
    key: 'root',
    storage: storage,
    stateReconciler: autoMergeLevel2, // see "Merge Process" section for details.
    transforms: [resetVolatileAppState]
};

const pReducer = persistReducer(persistConfig, rootReducers);

const middleware = [thunk];

// fifth parameter in createStore is for redux chrome plugin
const store = createStore(
    pReducer,
    initialState,
    compose(
    applyMiddleware(...middleware),
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__() // for development
    compose // for production
    )
);

export const persistor = persistStore(store);

export default store;
